module.exports = function getResource(label, vars = []) {
    const resources = { back: 'Back' };

    return resources[label];
};
